module.exports = __webpack_public_path__ + "static/media/not_found.3b8e9ae2.svg";